/* 首页相关 */

import request from '@/utils/request';

import { stringify } from 'qs';

/**
 * 小红点策略
 * @param params
 * @returns {Promise<TResult|TResult2|TResult1>}
 */
export async function getPolicyDot() {
  return request(`/api/policy/little_red_dot`,{})
}

/**
 * 已读小红点
 * @returns {Promise<TResult|TResult2|TResult1>}
 */
export async function readDot () {
  return request(`/api/policy/little_red_dot/read`,{
    method: 'POST',
  })
}

/**
 * 获取云设备列表
 * @param params
 * @returns {Promise<TResult|TResult2|TResult1>}
 */
export async function getCloudDeviceList () {
  return request(`/api/cloud_device/list`,{})
}

/**
 * 云设备重命名
 * @param params
 * @returns {Promise<TResult|TResult2|TResult1>}
 */
export async function cloudDeviceRename (params: object) {
  return request(`/api/cloud_device/rename?${stringify(params)}`,{
    method: 'POST',
    body: params
  })
}

/**
 * 云设备重启
 * @param params
 * @returns {Promise<TResult|TResult2|TResult1>}
 */
export async function cloudDeviceReboot (params: object) {
  return request(`/api/cloud_device/reboot?${stringify(params)}`,{})
}

/**
 * 云设备恢复出厂
 * @param params
 * @returns {Promise<TResult|TResult2|TResult1>}
 */
export async function cloudDeviceReset (params: object) {
  return request(`/api/cloud_device/reset?${stringify(params)}`,{})
}

/**
 * 云设备刷新
 * @param params
 * @returns {Promise<TResult|TResult2|TResult1>}
 */
export async function cloudDeviceRefresh (params: object) {
  return request(`/api/cloud_device/refresh?${stringify(params)}`,{})
}

/**
 * 获取消息弹窗
 * @param params
 * @returns {Promise<TResult|TResult2|TResult1>}
 */
export async function getNotifications (params: object) {
  return request(`/api/initialize/get`,{})
}

/**
 * 云设备播流
 * @param params
 * @returns {Promise<TResult|TResult2|TResult1>}
 */
export async function cloudDevicePlay (params: object) {
  return request(`/api/cloud_device/play?${stringify(params)}`,{
    method: 'POST',
  })
}

export async function uaBlackList () {
  return request(`/api//ua/black/list`,{})
}
